module.exports = __webpack_public_path__ + "img/serial_number.218c2710.jpg";